<div class="section-container">
    <sc-title content="Forma de pago" type="h3" [class.sc-color-grey-2]="!editMode"></sc-title>
    <ng-container *ngIf="editMode">
        <form [formGroup]="formGroup" *ngIf="formGroup && selectedPaymentMethod.value; else loadingTemplate">
            <div class="fields-block">
                <div class="row payment-method-selector" *ngIf="selectedPaymentMethod.value">
                    <sc-payment-method-confirm
                        [loading]="loading || loadingPaymentMethodsByUser"
                        [disabled]="loadingPaymentMethodsByUser"
                        [paymentFee]="selectedPaymentMethod.value.quoteNro"
                        [paymentTypeId]="selectedPaymentMethod.value.paymentTypeId"
                        [finalAmount]="selectedPaymentMethod.value.finalAmount"
                        (changeMethodClicked)="handleShowModal()"></sc-payment-method-confirm>
                </div>
                <!-- Débito -->
                <div class="row" *ngIf="selectedPaymentMethod.value.paymentTypeId === paymentTypeId.Debit">
                    <ng-container *ngIf="!loadingPaymentMethodsByUser">
                        <div class="col-12" *ngIf="cbuOptions?.length > 0">
                            <sc-payment-method-selector
                                formControlName="paymentMethodByUser"
                                [type]="'cbu'"
                                [options]="cbuOptions"></sc-payment-method-selector>
                        </div>
                        <div class="col-md-6 col-12" *ngIf="cbuOptions?.length === 0">
                            <sc-input
                                label="CBU"
                                formControlName="cbuNumber"
                                placeholder="1234567890123456789012"
                                maxlength="22"
                                [errorMessages]="errorMessages"
                                [icon]="setNumberFieldIcon(formGroup.get('cbuNumber'))"
                                (input)="onlyNumbers($event)">
                            </sc-input>
                        </div>
                    </ng-container>
                </div>
                <!-- Tarjeta de Crédito -->
                <div class="row" *ngIf="selectedPaymentMethod.value.paymentTypeId === paymentTypeId.Credit">
                    <ng-container *ngIf="!loadingPaymentMethodsByUser && creditCardTypes?.length">
                        <div class="col-12" *ngIf="creditCardOptions?.length > 0">
                            <sc-payment-method-selector
                                formControlName="paymentMethodByUser"
                                [type]="'credit'"
                                [creditCardTypeOptions]="creditCardTypes"
                                [options]="creditCardOptions">
                            </sc-payment-method-selector>
                        </div>
                        <ng-container *ngIf="creditCardOptions?.length === 0">
                            <div class="col-md-6 col-12">
                                <sc-select
                                    label="Selecciona la tarjeta"
                                    formControlName="creditCardType"
                                    placeholder="---"
                                    objectValue="name"
                                    [itemsAsync$]="creditCardTypes$"
                                    (optionSelected)="formGroup.get('creditCardNumber').setValue(null)"></sc-select>
                            </div>
                            <div class="col-md-6 col-12">
                                <sc-input label="Número de tarjeta"
                                    formControlName="creditCardNumber"
                                    placeholder="2000 3000 4000 5000"
                                    [isDisabled]="!formGroup.get('creditCardType').value"
                                    [errorMessages]="errorMessages"
                                    [maxlength]="getCreditCardValidLength(formGroup.get('creditCardType').value?.key)"
                                    [icon]="setNumberFieldIcon(formGroup.get('creditCardNumber'))"
                                    (input)="onlyNumbers($event)"></sc-input>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
                <!-- Cobradores -->
                <div class="row">
                    <div class="col-md-6 col-12"
                        [ngStyle]="(selectedPaymentMethod.value.paymentTypeId !== paymentTypeId.Cash) ? {'display': 'none'} : null">
                        <sc-select
                            label="Cobrador"
                            formControlName="collector"
                            [items]="collectorOptions"
                            [isReadonly]="collectorReadonly"
                            [isDisabled]="loading"></sc-select>
                    </div>
                    <div class="col-md-6 col-12" *ngIf="selectedPaymentMethod.value.paymentTypeId === paymentTypeId.Cash">
                        <sc-select
                            label="Envío de cupones"
                            formControlName="sendCouponsBy"
                            [items]="sendCouponsByOptions"
                            [isDisabled]="loading"></sc-select>
                    </div>
                </div>
            </div>
            <div class="buttons-block">
                <sc-button (onClick)="onSubmit()" [disabled]="loading || !canContinue || !formGroup.valid" id="payment-method-to-emit">Emitir</sc-button>
            </div>
        </form>
    </ng-container>
    <ng-container *ngIf="!editMode">
        <div class="section-submitted-data">
            <div>
                <div>
                    <span>Forma de pago</span><br>
                    <strong>{{ selectedPaymentMethod.value.title }}</strong>
                </div>
                <div>
                    <span>Cuotas</span><br>
                    <strong>{{ selectedPaymentMethod.value.quoteNro }}</strong>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-template #loadingTemplate>
        <div class="loading-block">
            <sc-icon icon="loading" size="2"></sc-icon>
        </div>
    </ng-template>
    <sc-payment-methods-modal #modalElement
        [paymentMethods$]="paymentMethods$"
        [feeOptions]="feeOptions"
        [defaultPaymentTypeId]="selectedPaymentMethod.value.paymentTypeId"
        [defaultFeeKey]="selectedPaymentMethod.value.quoteNro"
        [defaultCommercialDiscountId]="defaultCommercialDiscountId"
        [hideCommercialDiscount]="true"
        (recalculate)="handleRecalculate($event)"
        (applyChanges)="handleApplyModalChanges($event)"
        (cancelChanges)="handleCancelModalChanges($event)"></sc-payment-methods-modal>
</div>